import styled from '@emotion/styled';

export const StepWrapper = styled.div`
    width: 700px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[2]};
    padding: ${({ theme }) => `0 ${theme.savory.spacing[2]}`};
    max-height: 60vh;
    overflow-y: auto;
`;

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    label {
        margin-bottom: 0;
        display: inline-block;
    }
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[2]};
    margin-bottom: ${({ theme }) => theme.savory.spacing[2]};
`;

export const RadioOption = styled.label`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.savory.spacing[1]};
    cursor: pointer;
    font-size: ${({ theme }) => theme.font.size.normal};
`;

export const ConfirmationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.savory.spacing[3]};
    padding: ${({ theme }) => theme.savory.spacing[4]};
    text-align: center;
`;

export const ConfirmationTitle = styled.h2`
    font-size: ${({ theme }) => theme.font.size.large};
    color: ${({ theme }) => theme.color.black400};
`;

export const ConfirmationMessage = styled.p`
    font-size: ${({ theme }) => theme.font.size.normal};
    color: ${({ theme }) => theme.color.black200};
`;

// Operation Zone Select Step
export const TerritoryList = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: auto;
`;

export const TerritoryRadioRow = styled.label<{ isSelected?: boolean }>`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.savory.spacing[2]};
    padding: ${({ theme }) => `${theme.savory.spacing[1]} ${theme.savory.spacing[2]}`};
    border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
    cursor: pointer;
    background-color: ${({ theme, isSelected }) => (isSelected ? theme.color.grey100 : 'transparent')};

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${({ theme }) => theme.color.grey100};
    }

    &[data-disabled='true'] {
        opacity: 0.4;
        cursor: not-allowed;

        &:hover {
            background-color: transparent;
        }
    }
`;

export const TerritoryFlag = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background-color: ${({ theme }) => theme.color.grey100};
    border-radius: ${({ theme }) => theme.radius.main};
    font-size: 18px;
    flex-shrink: 0;
`;

export const TerritoryInfoBlock = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const TerritoryLabel = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const TerritoryCodeLabel = styled.span`
    font-weight: ${({ theme }) => theme.font.weight.regular};
    color: ${({ theme }) => theme.color.black200};
`;

export const TerritorySolution = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
`;

export const NoSelectionMessage = styled.p`
    margin: 0 0 ${({ theme }) => theme.savory.spacing[2]} 0;
    padding: ${({ theme }) => `${theme.savory.spacing[1]} ${theme.savory.spacing[3]}`};
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

// Operation Zone Config Step
export const ProviderGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.savory.spacing[3]};
    margin-bottom: ${({ theme }) => theme.savory.spacing[3]};
`;

export const ProviderCardButton = styled.button<{ isSelected?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.savory.spacing[2]};
    padding: ${({ theme }) => theme.savory.spacing[4]};
    border: 2px solid ${({ theme, isSelected }) => (isSelected ? theme.color.bloodyMary : theme.color.grey200)};
    border-radius: ${({ theme }) => theme.radius.main};
    background: ${({ theme }) => theme.color.white100};
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s;

    &:hover {
        border-color: ${({ theme }) => theme.color.bloodyMary};
    }

    & > i {
        font-size: 24px;
        color: ${({ theme, isSelected }) => (isSelected ? theme.color.bloodyMary : theme.color.black200)};
    }
`;

export const ProviderCardTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const ProviderCardDescription = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
`;

export const ConfigSectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.savory.spacing[2]};

    & > i {
        font-size: 20px;
        color: ${({ theme }) => theme.color.black400};
    }
`;

export const ConfigSectionTitle = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
`;

export const FieldsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.savory.spacing[2]};
`;

export const ProviderSectionLabel = styled.h3`
    font-size: ${({ theme }) => theme.font.size.normal};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.black400};
    margin: 0 0 ${({ theme }) => theme.savory.spacing[3]} 0;
`;
